export default "__VITE_ASSET__CsO1UAF5__"